<template>
    <div>
        Loading...
    </div>
</template>

<script>
import axios from '@/axios'
export default {    
  data () {
    return {
      localhost:true
    }
  },
  created () {
    if (this.$route.query.code) {
      const state = decodeURIComponent(this.$route.query.state).split('+Scoolio+')
      console.log(state)
      const payload = {
        code:this.$route.query.code,
        customer_id:state[0],
        token:state[1]
      }
      
      console.log(payload)
      this.authorize(payload, state[2]) 
    } else {
      this.$router.push('/')
    }
    console.log(this.$route)
    // const query = this.$route.params
  },
  methods:{
    
    authorize (payload, subdomain) {
      const url = `${process.env.VUE_APP_API_URL  }google/connect/${payload.customer_id}`
      console.log(url)
      
      axios.post(url, payload, {
        headers: {
          'Authorization': `Bearer ${payload.token}`
        }
      })
        .then((res) => {
          if (process.env.ENVIRONMENT === 'localhost') {
            window.open('http://localhost:8080/pages/settings', '_self')

          } else {
            window.open(`${subdomain}/pages/settings`, '_self')
            console.log(res)
          }
        })
        .catch((error) => {
          console.error(error)
        })
    /*   try {
        const data = await authorizationGoogle(this.$route.query.state, payload)
        console.log(data)
      } catch (error) {
        console.warn(error)
      } */
    }
  }
        
}
</script>

<style lang="scss" scoped>

</style>